// extracted by mini-css-extract-plugin
export default {"folder":"folder__pm-L+","error":"error__I7sId"};